<div class="padding-20 ui-g" id="c3_searchProducts_Modal">

  <!-- Bottoni Annulla e Aggiungi -->
  <div class="ui-dialog-footer fixed-buttons buttonsContainer">
    <button
      data-testid="annulla_products"
      pButton
      type="button"
      class="k-generic-btn footer-btn"
      (click)="onClickCancelProducts()"
      label="{{ 'common.cancel' | translate }}">
    </button>

    <button
      data-testid="aggiungi_products"
      pButton
      *ngIf="!readOnly"
      type="button"
      class="k-generic-btn footer-btn"
      (click)="onClickAddProducts()"
      label="{{ 'common.save' | translate }}">
    </button>

    <div class="clear_fix"></div>
  </div>

  <br />
  <br />
  <br />

  <div class="ui-g-12 campaignStoresTop">

    <app-campaign-3-kontable
      *ngIf="show.table"
      id="addBasketTable"
      [columns]="[
        { field: 'code', title: 'baskets.code' },
        { field: 'description', title: 'baskets.description' },
        { field: 'product_categories', title: 'baskets.category' },
        { field: 'product_department', title: 'baskets.department' },
        { field: 'barcode', title: 'baskets.barcode' }
      ]"
      [paginationType]="paginationType"
      [service]="basketService"
      [rowSelected]="rowSelected"
      [source]="productsNotInSelectedBasket"
      [showInfoButton]="false"
      [showGlobalFilter]="false"
      [showDetailsButton]="false"
      [showRecoverButton]="false"
      [showAddButton]="false"
      [showDeleteButton]="false"
      [showEditButton]="false"
      [allowSelectRow]="false"
      [showSelectButton]="true"
      [filterBySingleColumn]="false"
      (onSelected)="onProductsSelected($event)"
      #productsListTable>
    </app-campaign-3-kontable>

  </div>

  <br />
  <br />


</div>



// WEBPACK FOOTER //
// ./src/app/views/baskets/add-product-to-basket/add-product-to-basket.component.html